import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "relative z-[19]",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      style: {"backdrop-filter":"blur(3px)"},
      class: "fixed top-0 right-0 left-0 bottom-0 bg-gray-400 bg-opacity-75 transition-opacity"
    }, null, -1),
    _createElementVNode("div", { class: "fixed top-0 right-0 left-0 bottom-0 z-10 overflow-y-hidden" }, [
      _createElementVNode("div", {
        id: "dialog",
        class: "bounce-modal-animation flex min-h-full items-center justify-center p-0 px-4 text-center"
      }, [
        _createElementVNode("div", { class: "rounded-md bg-background p-5 text-base font-semibold text-grey text-grey" }, [
          _createElementVNode("div", null, "Страница находится в разработке"),
          _createElementVNode("div", null, "совсем скоро она будет готова")
        ])
      ])
    ], -1)
  ]))]))
}